import React, {
  PropsWithChildren,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLogo } from '../../contexts/AppLogoContext';
import SWLogo from '../../images/SW-Logo-White.svg';
import { Redirect } from 'react-router';
import AuthenticationContext from '../../contexts/AuthenticationContext';
import Loading from '../Shared/ResourceIndex/Loading';

/**
 * Narrow & centered
 *
 * Used for login and recovery
 */
const NarrowLayout: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const { appLogo, isCustomLogo, appLogoNavy } = useLogo();
  const [tenantInfo, setTenantInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const authStore = useContext(AuthenticationContext);

  useEffect(() => {
    if (window.location.host.split('.').length > 1) {
      const tenantName = window.location.host.split('.')[0];

      getTenant(tenantName);
    } else {
      setLoading(false);
    }
  }, [window.location.host]);

  const getTenant = async (name: string) => {
    try {
      const tenantData = await authStore.getTenantByName(name);

      setTenantInfo(tenantData);
    } catch (error) {
      setTenantInfo(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  if (
    !tenantInfo &&
    window.location.origin !== process.env.REACT_APP_LOGIN_URL
  ) {
    return <Redirect to={'/error'} />;
  }

  return (
    <div className='modal-login-form'>
      <div className='modal-main-login-form'>
        <div className='layout--narrow'>
          {/* Left logo container (hidden on small screens) */}
          <div className='login-logo-container'>
            <img src={appLogo!} className='app-logo' alt='logo' />
          </div>

          {/* Right form container */}
          <div className='login-form-container'>
            <div className='login-form-header'>
              <img src={appLogoNavy!} className='app-logo' alt='logo' />
            </div>

            {React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                return React.cloneElement(child as ReactElement, {
                  // pass extra props here if needed
                });
              }
              return child;
            })}
          </div>
        </div>

        {isCustomLogo && (
          <div className='powerdby-logo-container'>
            <span className='powerd-by-logo-span'>
              Powered By <img src={SWLogo} alt='Powered By Logo' />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NarrowLayout;
